import { VERSION_UPDATED } from '../reducers/versionStatus';

const POLL_INTERVAL_MS = 60000;
const VERSION_ENDPOINT = '/version.json';

let currentVersion = null;
let pollTimer = null;

async function fetchVersion() {
    try {
        const response = await fetch(`${VERSION_ENDPOINT}?t=${Date.now()}`);
        if (!response.ok) return null;
        const data = await response.json();
        return data.version ?? null;
    } catch {
        return null;
    }
}

export function startVersionPolling(store) {
    //if (process.env.NODE_ENV === 'development') return;

    fetchVersion().then(version => {
        currentVersion = version;
    });

    pollTimer = setInterval(async () => {
        const latestVersion = await fetchVersion();
        if (latestVersion != null && currentVersion != null && latestVersion !== currentVersion) {
            store.dispatch({ type: VERSION_UPDATED });
        }
    }, POLL_INTERVAL_MS);
}

export function stopVersionPolling() {
    if (pollTimer) {
        clearInterval(pollTimer);
        pollTimer = null;
    }
}
